




















import { Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

@Component
export default class Modal extends Vue {
    @Prop({ type: Boolean, default: false }) readonly slim!: boolean
    @Prop({ type: Boolean, default: false }) readonly small!: boolean
    @Prop({ type: Boolean, required: true }) readonly value!: boolean
    @Prop({ type: Boolean, default: true }) readonly closeOnOutsideClick!: boolean
    @Prop({ default: '60%' }) readonly minWidth!: string
    @Ref() modal: HTMLDivElement
    @Ref() wrapper: HTMLDivElement

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.modal, {
            opacity: 0,
        })

        gsap.set(this.wrapper, {
            opacity: 0,
            scale: .3,
        })

        gsap.to(this.modal, .2, {
            opacity: 1,
            ease: 'back.out',
        })

        gsap.to(this.wrapper, .3, {
            opacity: 1,
            scale: 1,
            ease: 'back.out',
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, .2, {
            opacity: 0,
            scale: .3,
            ease: 'back.in',
        })

        gsap.to(this.modal, .3, {
            opacity: 0,
            ease: 'back.in',
            onComplete,
        })
    }

    handleOutsideClick(): void {
        if (this.closeOnOutsideClick) {
            this.closeModal()
        }
    }

    closeModal(): void {
        this.$emit('input', false)
    }

    get isVisible(): boolean {
        return this.value === true
    }

    get componentClass() {
        return {
            'modal': true,
            'modal--slim': this.slim,
            'modal--small': this.small,
        }
    }
}
